import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import PropTypes from 'prop-types';
import SafeAnchor from '../SafeAnchor';
import { useClassNames } from '../utils';
var BreadcrumbItem = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _props$as = props.as,
      Component = _props$as === void 0 ? SafeAnchor : _props$as,
      href = props.href,
      _props$classPrefix = props.classPrefix,
      classPrefix = _props$classPrefix === void 0 ? 'breadcrumb-item' : _props$classPrefix,
      title = props.title,
      target = props.target,
      className = props.className,
      style = props.style,
      active = props.active,
      children = props.children,
      rest = _objectWithoutPropertiesLoose(props, ["as", "href", "classPrefix", "title", "target", "className", "style", "active", "children"]);

  var _useClassNames = useClassNames(classPrefix),
      merge = _useClassNames.merge,
      withClassPrefix = _useClassNames.withClassPrefix;

  var classes = merge(className, withClassPrefix({
    active: active
  }));

  if (active) {
    return /*#__PURE__*/React.createElement("span", _extends({
      ref: ref
    }, rest, {
      style: style,
      className: classes
    }), children);
  }

  return /*#__PURE__*/React.createElement(Component, _extends({}, rest, {
    href: href,
    title: title,
    target: target,
    ref: ref,
    style: style,
    className: classes
  }), children);
});
BreadcrumbItem.displayName = 'BreadcrumbItem';
BreadcrumbItem.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
  href: PropTypes.string,
  title: PropTypes.string,
  target: PropTypes.string,
  classPrefix: PropTypes.string,
  as: PropTypes.elementType
};
export default BreadcrumbItem;